module.exports = __webpack_public_path__ + "static/bg-welcome-23a5d07fd3782efe85909de6d449472a.jpg";